import { RegisterAsGroupIcon } from "@/assets";
import TripIcon24 from "@/assets/SVG/TripIcon24";
import AddAccont24 from "@/assets/SVG/addAccont24";
import NoteIcon24 from "@/assets/SVG/noteIcon24";
import ReportIcon24 from "@/assets/SVG/reportIcon24";
import {
  Box,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useMemo, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DashboardIcon from "../../assets/SVG/dashboard";
import logo from "../../assets/image/new-logo.png";
import SidebarAreaManager from "../areaManager/sidebarAreaManager";
import SidebarGroup from "./sidebarGroup";

export function OptionsSidebar({
  icon,
  text,
  select,
  onClick,
  href,
  arrowIcon,
}) {
  return (
    <>
      {href ? (
        <Link to={href}>
          <Box
            sx={{ cursor: "pointer" }}
            display="flex"
            bgcolor={
              !arrowIcon
                ? select
                  ? "var(--emr-white)"
                  : "transparent"
                : "transparent"
            }
            padding="5px 6px"
            borderRadius="9px"
            onClick={onClick}
            justifyContent={"space-between"}
          >
            <Box display="flex">
              <Box
                display="flex"
                justifyContent={"center"}
                alignContent={"center"}
                alignItems={"center"}
              >
                <IconButton
                  sx={{
                    padding: "5px",
                    borderRadius: "6px",
                    backgroundColor: "var(--emr-primary)",
                    "&:hover": {
                      backgroundColor: "var(--emr-primary)",
                      transform: "scale(1.1)",
                    },
                  }}
                >
                  {icon}
                </IconButton>
                <Typography mr="10px" fontSize="16px" color="var(--emr-text)">
                  {text}
                </Typography>
              </Box>
            </Box>
            {arrowIcon && <Typography>...</Typography>}
          </Box>
        </Link>
      ) : (
        <Grid
          display={"flex"}
          justifyContent={"space-between"}
          width={"100%"}
          alignItems={"center"}
          padding={"5px"}
        >
          <Grid
            sx={{ cursor: "pointer" }}
            className={"emr-menu-item"}
            color="var(--emr-text)"
            display="flex"
            flexDirection={"row"}
            justifyContent="space-between"
            bgcolor={
              !arrowIcon
                ? !select
                  ? "var(--emr-white)"
                  : "transparent"
                : "transparent"
            }
            borderRadius="9px"
            onClick={onClick}
            width={"100%"}
          >
            <Box display="flex">
              {icon}
              <Typography mr="10px" fontSize="16px" color="var(--emr-text)">
                {text}
              </Typography>
            </Box>
            {arrowIcon && <Typography>...</Typography>}
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default function Sidebar({ onClose, Role }) {
  const location = useLocation();

  const getSelectedIndex = (pathname) => {
    if (pathname === "/") return 0;
    if (pathname.startsWith("/notes")) return 5;
    if (pathname.startsWith("/groups")) return 1;
    if (pathname.startsWith("/projects")) return 2;
    if (pathname.startsWith("/users")) return 3;
    if (pathname.startsWith("/reports")) return 4;
    return 0;
  };
  const select = useMemo(
    () => getSelectedIndex(location.pathname),
    [location.pathname],
  );

  const md = useMediaQuery("(max-width:450px)");
  const navigate = useNavigate();
  const ref = useRef(null);

  useEffect(() => {
    if (!md) return;
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, md]);

  return (
    <>
      {md && (
        <div
          style={{
            backgroundColor: "#d1cbcba0",
            zIndex: "50",
            position: "fixed",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
          }}
        ></div>
      )}
      <Box
        ref={ref}
        sx={
          md
            ? {
                position: "absolute",
                zIndex: 99,
                width: "250px",
                height: "100vh",
                borderRadius: "17px",
                background: "white",
                padding: "6px",
                display: "grid",
                alignContent: "space-between",
                overflow: "hidden",
              }
            : {
                width: "250px",
                height: "90vh",
                borderRadius: "17px",
                background: "var(--emr-background-color)",
                mt: "19px",
                padding: "6px",
                display: "grid",
                alignContent: "space-between",
                overflow: "hidden",
              }
        }
      >
        <Box
          sx={{
            overflow: "auto",
            padding: "10px",

            // "::-webkit-scrollbar": {
            //   display: "none",
            // },
          }}
        >
          <Grid
            display={"flex"}
            flexDirection={"row"}
            gap={"8px"}
            alignItems={"center"}
          >
            <IconButton
              sx={{
                backgroundColor: "var(--emr-primary)",
                borderRadius: "8px",
                width: "40px",
                height: "40px",
                "&:hover": {
                  backgroundColor: "var(--emr-primary)",
                },
              }}
            >
              <img
                onClick={() => navigate("/")}
                style={{ width: "20px", height: "auto", cursor: "pointer" }}
                src={logo}
              />
            </IconButton>
            <Grid display={"flex"} flexDirection={"column"}>
              <Typography variant="caption">سامانه اردو جهادی اثر</Typography>
              <Typography variant="caption">
                سکوی مدیریت گروه‌های جهادی
              </Typography>
            </Grid>
          </Grid>
          <Box height="10px"></Box>
          {Role?.role === "ADMIN" && (
            <Box mt={"50px"}>
              <Typography color={"text.primary"}>ابزار</Typography>
              <Grid
                mr={"10px"}
                mt={"10px"}
                gap={"10px"}
                display={"flex"}
                flexDirection={"column"}
              >
                <OptionsSidebar
                  href="/"
                  select={select === 0}
                  text="داشبورد شما"
                  icon={<DashboardIcon color={"white"} />}
                />
                <OptionsSidebar
                  href="/notes"
                  select={select === 5}
                  text="یادداشت‌ها"
                  icon={<NoteIcon24 width={24} color={"white"} />}
                />
                <OptionsSidebar
                  href="/groups"
                  select={select === 1}
                  text="گروه‌های جهادی"
                  icon={<RegisterAsGroupIcon color={"white"} />}
                />
                <OptionsSidebar
                  href="/projects"
                  select={select === 2}
                  text="پروژه‌های جهادی"
                  icon={<TripIcon24 color={"white"} />}
                />
                <OptionsSidebar
                  href="/users"
                  select={select === 3}
                  text="ثبت‌نام کنندگان"
                  icon={<AddAccont24 color={"white"} />}
                />
                <OptionsSidebar
                  href="/reports"
                  select={select === 4}
                  text="گزارشات"
                  icon={<ReportIcon24 color={"white"} />}
                />
              </Grid>
            </Box>
          )}
          {Role?.role === "GROUP" && <SidebarGroup />}
          {Role?.role === "JAHADI" && <SidebarAreaManager />}
        </Box>
        {/* <Box sx={{ borderTop: "solid 1px var(--emr-disable)" }}>
          <OptionsSidebar
            onClick={() => setSelect(10)}
            select={select === 10 ? false : true}
            text="داشبورد"
            icon={<SupportIcon color={"white"} />}
          />
          <OptionsSidebar
            onClick={() => setSelect(11)}
            select={select === 11 ? false : true}
            text="گروه ها"
            icon={<SettingIcon color={"white"} />}
          />
        </Box> */}
      </Box>
    </>
  );
}
